export default __webpack_public_path__ + "assets/284d479eeeb5d63eb3de2b1096f22b23.svg";